import { Directive, Host, Self } from '@angular/core';
import { NumericTextBoxComponent } from '@progress/kendo-angular-inputs';
import { TABINDEX } from './tab-index.directive';

/**
 * A directive that automatically sets the tabindex property for Kendo NumericTextBox components.
 * 
 * This directive ensures consistent tab navigation behavior across Kendo UI components
 * by setting a default tabindex value when the component's tabindex is 0 (browser default).
 * 
 * @example
 * ```html
 * <kendo-numerictextbox [(ngModel)]="value"></kendo-numerictextbox>
 * ```
 */
@Directive({
  selector: 'kendo-numerictextbox',
  standalone: true,
})
export class KendoNumericTextBoxTabIndexDirective {
  /**
   * Creates an instance of the directive and sets the tabindex if needed.
   * 
   * @param kendoComponent The Kendo NumericTextBox component instance
   */
  constructor(@Host() @Self() kendoComponent: NumericTextBoxComponent) {
    if (kendoComponent.tabindex == 0) {
      kendoComponent.tabindex = TABINDEX;
    }
  }
}
